<template>
  <div :class="$style.container">
    <ol v-if="activities.length > 0">
      <li v-for="activity in activities" :key="activity.id">
        <CallInfo
          :activity="activity"
          :info="['category', 'stage', 'rating']"
          :actions="['play']"
          :class="$style.callInfo" />
      </li>
    </ol>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import store from '@/lib/store'
import { jiminnyHost } from '@/helpers/region'
import CallInfo from '@/components/shared/CallInfo/CallInfo'

export default {
  components: {
    CallInfo
  },
  props: [
    'isRep'
  ],
  data () {
    return {
      activities: [],
      dateFormat: 'YYYY-MM-DD HH:mm:ss',
      user: store.get('user')
    }
  },
  mounted () {
    this.retrieveActivities()
  },
  methods: {
    async retrieveActivities () {
      try {
        const response = await axios.get(`${jiminnyHost()}/api/v1/activity/search`, {
          params: this.getParams()
        })

        this.activities = response.data.results
      } catch (error) {
        console.error(error)
      }
    },
    getParams () {
      return this.isRep
        ? this.getUserParams()
        : this.getTeamParams()
    },
    getUserParams () {
      return {
        'status': ['completed'],
        'user_id': [this.user.id],
        'start_date': this.getStartDate(),
        'end_date': this.getEndDate(),
        'sort_by': 'dateHeld',
        'sort_direction': 'desc',
        'exclude': ['stats']
      }
    },
    getTeamParams () {
      return {
        'status': ['completed'],
        'excluded_user_id': this.user.id,
        'sort_by': 'dateHeld',
        'sort_direction': 'desc',
        'exclude': ['stats']
      }
    },
    getStartDate () {
      return moment().add(0, 'month').startOf('month').format(this.dateFormat)
    },
    getEndDate () {
      return moment().add(0, 'month').endOf('month').format(this.dateFormat)
    }
  }
}
</script>

<style module lang="less" src="./RecentActivity.less"></style>



// WEBPACK FOOTER //
// RecentActivity.vue?518ff69c